<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    placehoder="Alege status"
    required
  ></v-select>
</template>

<script>
import VSelect from '../ui/VSelect.vue';
import vendorOrdersApi from "../../api/resources/vendorOrdersApi";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
    orderId: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getOptions() {
      vendorOrdersApi.transitionsIndex(this.orderId).then((response) => {
        this.options = response.data.map((status) => {
          return { text: status.label, value: status.id };
        });
      });
    },
  },

  mounted() {
    this.getOptions();
  },
};
</script>

<style></style>
